import { getStorage, setStorage } from '@/utils'
export function useStorage(key: string, value?: any) {
  try {
    const val = getStorage(key)
    if (val) {
      // 判断是否能转成obj
      try {
        value = JSON.parse(val)
      } catch {
        value = val
      }
    } else {
      if (typeof value === 'object') {
        value = JSON.stringify(value)
      }
      setStorage(key, value)
    }
  } catch (e) {
    console.error(e)
  }

  const data = ref(value)

  watch(
    data,
    () => {
      try {
        if (typeof data.value === 'object') {
          setStorage(key, JSON.stringify(data.value))
        } else {
          setStorage(key, data.value)
        }
      } catch (e) {
        console.error(e)
      }
    },
    { deep: true },
  )

  return data
}
